import { render } from "./UserInfoContent.vue?vue&type=template&id=1d898d60&scoped=true"
import script from "./UserInfoContent.vue?vue&type=script&lang=js"
export * from "./UserInfoContent.vue?vue&type=script&lang=js"

import "./UserInfoContent.vue?vue&type=style&index=0&id=1d898d60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d898d60"]])

export default __exports__